<template>
    <b-modal
        id="editPrice"
        title="Editar Valor da Correção"
        centered
        hide-footer
    >
        <b-overlay :show="loading" rounded="sm">

            <!-- Field -->
            <b-form-group
                label="Professor">
                <b-input v-model="name" disabled />
            </b-form-group>

            <!-- Field -->
            <b-form-group
                label="Preço Unitário"
                description="Qual é o valor que esse corretor vai receber por cada redação corrigida ?">

                <money v-model="form.price" v-bind="money" class="form-control" inputmode="tel" min="0" />

            </b-form-group>

            <b-form-group>
                <b-button type="button" variant="primary" @click="update" :disabled="loading">
                    Editar Preço
                </b-button>
            </b-form-group>
        </b-overlay>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            id: null,
            name: null,
            form: {
                price: 0
            },
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
                masked: false
            }
        }
    },
    created() {

        this.$root.$on('editPrice', (teacher) => {

            this.id = teacher.id
            this.name = teacher.name
            this.form.price = teacher.permissions.price

            this.$bvModal.show('editPrice')
        })

    },
    methods: {

        update() {
            this.loading = true;
            axios.put('/teacher/teachers/' + this.id + '/price', this.form)
                .then((result) => {

                    // Load
                    this.$emit('updated')

                    // Message
                    this.$toast.success('Preço atualizado com sucesso :)');

                    // Close Modal
                    this.$bvModal.hide('editPrice')

                    // Load
                    window.location.reload();

                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
